



















import { Component, Vue } from 'vue-property-decorator';
import i18n from '@/i18n';
import { GQL_generateRecurringOrdersForDate } from '@/queries/__generated__/generateRecurringOrdersForDate';
import gql from 'graphql-tag';

export const GENERATE_RECURRING_ORDERS_FOR_DATE = gql`
  mutation generateRecurringOrdersForDate($date: Date!) {
    generateRecurringOrdersForDate(input: { date: $date }) {
      orders {
        id
        number
        date
      }
    }
  }
`;


@Component
export default class RecurringOrderGenerateForDateButton extends Vue {
  private date = this.$dayjs().format('YYYY-MM-DD');
  private loading = false;

  private runForDate() {
    this.loading = true;

    this.$apollo.mutate<GQL_generateRecurringOrdersForDate>({
      mutation: GENERATE_RECURRING_ORDERS_FOR_DATE,
      variables: {
        date: this.date,
      },
    }).then(({ data }) => {
      const orders = data?.generateRecurringOrdersForDate?.orders || [];
      this.$sMessage.success(
        i18n.t('RecurringOrder.generateForDateSuccess', {
          count: orders.length,
          date: this.date,
        }),
      );
      this.$emit('generated');
    }).catch(() => {
      this.$sMessage.error(i18n.t('Message.somethingWentWrong'));
    }).finally(() => {
      this.loading = false;
    });
  }
}
